import React, { useEffect, useState } from "react";
import axios from "axios";
import { Route, Routes } from "react-router-dom";

import Add from "./Add";
import Table3 from "./Table3";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import {
  getDateColumnsInRange,
  getDefaultRange,
  getMonthsInRange,
  isValidRange,
  normalizeRangeData,
} from "./rangeHelpers";

const Ravotxoji = () => {
  const defaultRange = getDefaultRange();
  const [toggle, setToggle] = useState(2);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);
  const [data, setData] = useState();
  const [rangeData, setRangeData] = useState();
  const [range, setRange] = useState(defaultRange);
  const [localRange, setLocalRange] = useState(defaultRange);
  const [rangeColumns, setRangeColumns] = useState([]);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const tabs = [
    { title: "Oraliq", id: 2, type: "text" },
    { title: "Oylik", id: 1, type: "text" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await axios
        .get(
          getEnv("REACT_APP_BASE_URL") +
            "/v1/region/ravotxoji/index?month=" +
            month,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Server bilan bog'lanishda xato!");
        });

      if (res) {
        setData(res.data);
      }

      setLoading(false);
    };

    fetchData();
  }, [month]);

  useEffect(() => {
    if (toggle !== 2) {
      return;
    }

    if (!isValidRange(range)) {
      setRangeColumns([]);
      setRangeData({});
      return;
    }

    const fetchRangeData = async () => {
      setLoading(true);
      const columns = getDateColumnsInRange(range.from, range.to);
      const months = getMonthsInRange(range.from, range.to);

      try {
        const responses = await Promise.all(
          months.map((rangeMonth) =>
            axios.get(
              getEnv("REACT_APP_BASE_URL") +
                "/v1/region/ravotxoji/index?month=" +
                rangeMonth,
              header()
            )
          )
        );
        const monthlyData = {};
        months.forEach((rangeMonth, index) => {
          monthlyData[rangeMonth] = responses[index]?.data || {};
        });

        setRangeColumns(columns);
        setRangeData(normalizeRangeData(monthlyData, columns));
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
        setRangeColumns(columns);
        setRangeData({});
      } finally {
        setLoading(false);
      }
    };

    fetchRangeData();
  }, [range, toggle]);

  const applyRange = () => {
    if (!isValidRange(localRange)) {
      alert("Sana oralig'ini to'g'ri kiriting!");
      return;
    }

    setRange(localRange);
  };

  return (
    <div>
      <ContentTop>
        <ul
          className='content-top-left suv-omborlari'
          style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <li>Ravotxoji g/u</li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          {toggle === 1 ? (
            <>
              <input
                type='month'
                className='form-control form-control-sm'
                value={lmonth}
                onChange={(e) => setLmonth(e.target.value)}
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={() => setMonth(lmonth)}>
                Ok
              </button>
            </>
          ) : (
            <>
              <span className='text-muted small mr-2'>Dan</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.from}
                onChange={(e) =>
                  setLocalRange({ ...localRange, from: e.target.value })
                }
              />
              &nbsp;&nbsp;
              <span className='text-muted small mr-2'>Gacha</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.to}
                onChange={(e) =>
                  setLocalRange({ ...localRange, to: e.target.value })
                }
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={applyRange}>
                Ok
              </button>
            </>
          )}
        </ul>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <div className='tabs-content-item active'>
          <div className='table-box-con'>
            {loading ? (
              <LoadingCard loading={loading} heightSize='80vh' />
            ) : (
              <Routes>
                <Route
                  path='/'
                  element={
                    toggle === 1 ? (
                      <Table3 data={data} month={month} setDate={setDate} />
                    ) : (
                      <Table3
                        data={rangeData}
                        month={range.from.slice(0, 7)}
                        dateColumns={rangeColumns}
                        setDate={setDate}
                      />
                    )
                  }
                />
                <Route
                  path='/add'
                  element={<Add date={date} setDate={setDate} />}
                />
              </Routes>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ravotxoji;
